import { useSelector } from 'react-redux';

const useProgressValue = () => {
  const { currentPageIDX, screensConfigs } = useSelector((state) => state.view);
  return ((currentPageIDX + 1) / (screensConfigs.length - 1)) * 100;
};

export default useProgressValue;
